var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.show,"opacity":0.2,"color":"rgba(255, 255, 255, 0.2)","z-index":"9999"}},[_c('div',{staticClass:"loading-container"},[_c('v-progress-circular',{attrs:{"size":40,"width":4,"color":"indigo","indeterminate":""}}),_c('div',{staticClass:"mt-4 indigo--text"},[_vm._v(_vm._s(_vm.message))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }